export default __webpack_public_path__ + "static/media/Git.b4585dda.png";